import React, { useCallback, useEffect } from "react";

import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { forwardRef } from "react";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// const types = ["error", "warning", "info", "success"];
const SnackBar = ({ message, type, onClose, open }) => {
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    onClose();
  };

  const onCloseCallBack = useCallback(onClose, [onClose]);

  //Disapper tost after 5 seconds
  useEffect(() => {
    const timeOutToast = setTimeout(() => {
      onCloseCallBack();
    }, 5000);
    return () => {
      clearTimeout(timeOutToast);
    };
  }, [onCloseCallBack]);

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
      >
        <Alert onClose={handleClose} severity={type || "success"} sx={{ width: "100%", whiteSpace: "pre" }}>
          {message}
        </Alert>
      </Snackbar>
    </Stack>
  );
};

export default React.memo(SnackBar);
